const decimal = (value: string | number): string =>
  String(value).replace(/[^0-9.]|\.(?=.*\.)/g, '');

export default decimal;
